import { DateTime } from "luxon";
import { convertTimestampToLuxonOrDefaultNow } from "../../utils/convertTimestampToLuxonOrDefaultNow";
export const createTaskerMessage = (message) => {
    if (!assertTaskerMessageType(message, "save")) {
        throw new Error("TaskerMessageType.save failed");
    }
    return message;
};
export const assertTaskerMessageType = (data, mode = "load") => {
    if (!data || typeof data !== "object") {
        throw new Error("TaskerMessageType must be an object");
    }
    const message = data;
    // Required fields based on mode
    let requiredFields = [
        "messageMeta",
        "message",
        "mediaFiles",
        "source",
        "status",
    ];
    if (mode === "load") {
        requiredFields.push("id", "timestamp", "createdAt", "updatedAt");
    }
    for (const field of requiredFields) {
        if (!(field in message)) {
            throw new Error(`TaskerMessageType is missing required field: ${field}`);
        }
    }
    // Type checks
    if (mode === "load" && typeof message.id !== "string") {
        throw new Error("TaskerMessageType.id must be a string");
    }
    // Timestamp validation based on mode
    if (mode === "load") {
        if (!(message.timestamp instanceof DateTime)) {
            throw new Error("TaskerMessageType.timestamp must be a DateTime");
        }
        if (!(message.createdAt instanceof DateTime)) {
            throw new Error("TaskerMessageType.createdAt must be a DateTime");
        }
        if (!(message.updatedAt instanceof DateTime)) {
            throw new Error("TaskerMessageType.updatedAt must be a DateTime");
        }
    }
    return true;
};
export const createTaskerMessageConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(taskerMessage) {
        if (!assertTaskerMessageType(taskerMessage, "save")) {
            throw new Error("TaskerMessageType.save failed");
        }
        const data = {
            ...taskerMessage,
            timestamp: convertToFirestoreTimestampOrDefaultServerTime(taskerMessage.timestamp),
            createdAt: convertToFirestoreTimestampOrDefaultServerTime(taskerMessage.createdAt),
            updatedAt: convertToFirestoreTimestampOrDefaultServerTime(taskerMessage.updatedAt),
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const taskerMessage = {
            ...data,
            id: snapshot.id,
            timestamp: convertTimestampToLuxonOrDefaultNow(data.timestamp),
            createdAt: convertTimestampToLuxonOrDefaultNow(data.createdAt),
            updatedAt: convertTimestampToLuxonOrDefaultNow(data.updatedAt),
        };
        if (!assertTaskerMessageType(taskerMessage, "load")) {
            throw new Error("TaskerMessageType.load failed");
        }
        return taskerMessage;
    },
});
//# sourceMappingURL=TaskerMessage.js.map